import { Component, HostListener, Injector, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BaseView } from 'src/app/submodules/angular-ui-common/base-view';

@Component({
  selector: 'app-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.scss']
})
export class ContactsComponent extends BaseView {

  constructor(
    protected _injector: Injector
   ) { 
    super(_injector);
  }

  @HostListener('document:click', ['$event'])
  private onClick(event) {
    if(event.target.className.split(' ').includes('goToMeeting'))  
      this.goToMeeting()
  }

  goToMeeting(){
    this._injector.get(Router).navigate(['/private/']);
  }
}
